import React, { useState, useEffect } from 'react';
import { loadImages } from '@root/shared/loadImages';
import ImageLogoA from '@root/assets/logoA.png';
import './index.less';

const PageLoading = () => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    loadImages([ImageLogoA])
      .then(() => {
        setLoaded(true);
      })
      .catch((e) => {
        console.log(e);
      });
  }, []);

  if (!loaded) {
    return null;
  }

  return (
    <div className="page-loading-wrap">
      <div className="page-loading">
        <div className="page-loading-logo">
          <img className="logo-image" src={ImageLogoA} />
        </div>
        <div className="page-loading-shadow" />
      </div>
    </div>
  );
};

export default PageLoading;
